import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuLabsIcon extends BaseIcon {
  getChildren = () => [
    <path d="M53.8 59.4c-.3.4-.7.6-1.2.6h-37c-.8 0-1.4-.6-1.4-1.4 0-.2 0-.4.1-.5l14.5-36.6.4-1V.1H39v20.5l.4 1L53.9 58c.2.5.1 1-.1 1.4z" fill="#e45785"/>,
    <path d="M25 24V11h-8v16l-2.6 1.1c-5.2 2.4-8.5 7.7-8.5 13.4 0 5.1 2.6 9.6 6.6 12.3L25 24z" opacity=".71" fill="#8d8da0"/>,
    <path d="M20.7 56.3c5.7 0 10.9-3.3 13.4-8.5 3.5-7.4.3-16.2-7.1-19.7l-.7-.3-11 27.5c1.6.6 3.5 1 5.4 1z" fill="#9c3b62"/>
    ]
  getViewBox = () => '0 0 60 60'
}
